import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import AuthLayout, { Message } from './AuthLayout';
import { accent } from '../theme';

// Where email confirmation links land after signup.
// Supabase reads the token from the URL automatically
// (detectSessionInUrl), so we just wait for the session to settle.
export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    async function check() {
      const { data, error } = await supabase.auth.getSession();
      if (cancelled) return;

      if (error) { setError(error.message); return; }
      if (data?.session) { navigate('/hub', { replace: true }); return; }

      // Session may still be settling — give it a moment before giving up.
      setTimeout(async () => {
        if (cancelled) return;
        const { data: retry } = await supabase.auth.getSession();
        if (retry?.session) navigate('/hub', { replace: true });
        else setError('That link has expired or has already been used.');
      }, 1200);
    }

    check();
    return () => { cancelled = true; };
  }, [navigate]);

  return (
    <AuthLayout
      eyebrow={error ? 'Problem' : 'One moment'}
      title={error ? 'That link didn\u2019t work.' : 'Confirming your account\u2026'}
    >
      {error && (
        <>
          <Message tone="error">{error}</Message>
          <Link to="/login" style={{ color: accent.lime, fontSize: 14 }}>
            Back to log in
          </Link>
        </>
      )}
    </AuthLayout>
  );
}
